class WishlistAddForm {
    constructor(passedElement) {
        let self = this;

        self.elem = passedElement;
        self.checkbox = self.elem.querySelector('[data-wishlist-checkbox]');
        self.wishlistButton = document.querySelector('[data-wishlist-button]');
    }

    init() {
        let self = this;

        self.checkbox.addEventListener('change', evt => {
            let formData = new FormData(self.elem);

            fetch('/', {
                method: 'post',
                body: formData,
                headers: {
                    'Accept': 'application/json',
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then(function(response) {
                response.json().then(function(data) {
                    self.updateWishlistButtonCount(data.items[0].action);
                });
            });
        });
    }

    updateWishlistButtonCount(action) {
        let self = this;

        let wishlistButtonCountElem = document.querySelector('[data-wishlist-button-count]');
        let wishlistButtonCount = parseInt(wishlistButtonCountElem.textContent);

        let newCount = action === 'added' ? wishlistButtonCount + 1 : wishlistButtonCount - 1;

        if(newCount === 0) {
            self.wishlistButton.classList.remove('has-items');
        } else {
            self.wishlistButton.classList.add('has-items');
        }

        wishlistButtonCountElem.textContent = newCount;
    }
}

export default WishlistAddForm;
